import { createAuthClient } from 'better-auth/react';

const apiUrl = import.meta.env.VITE_API_URL ?? 'http://localhost:3000';

/**
 * Browser Better Auth client (ADR-006). Talks to `/api/auth/*` with cookies.
 * The SPA never stores a session token in localStorage.
 */
export const authClient = createAuthClient({
  baseURL: apiUrl,
});
